import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    fromDate: null,
    toDate: null,
    jobIds: [],
    clients: [],
    stage: null,
};

const reportSlice = createSlice({
    name: "report",
    initialState,
    reducers: {
        setFromDate: (state, action) => {
            state.fromDate = action.payload;
        },
        setToDate: (state, action) => {
            state.toDate = action.payload;
        },
        setJobIds: (state, action) => {
            state.jobIds = action.payload;
        },
        setClients: (state, action) => {
            state.clients = action.payload;
        },
        setStage: (state, action) => {
            state.stage = action.payload;
        },
        resetFilters: (state) => {
            state.fromDate = null;
            state.toDate = null;
            state.jobIds = [];
            state.clients = [];
            state.stage = null;
        },
    },
});

export const { setFromDate, setToDate, setJobIds, setClients, setStage, resetFilters } = reportSlice.actions;
export const selectReportFilters = (state) => state.report;
export default reportSlice.reducer;